import React, {MouseEvent, useCallback} from "react";
import styles from "./Facet.module.css";
import {AggregationType} from "../../SearchResult";
import {selectFacet, unselectFacet} from "../../SearchActions";
import {useDispatch} from "react-redux";
import {Checkbox, FormControlLabel} from "@material-ui/core";
import PuiTypography from "../../../../components/elements/PuiTypography";
import CheckboxIcon from "../../../../common/components/images/CheckboxIcon";
import CheckboxCheckedIcon from "../../../../common/components/images/CheckboxCheckedIcon";
import useResponsive from "../../../../common/useResponsive";

interface FacetProps {
    type: AggregationType;
    facet: string;
    count: number;
    isActive: boolean;
}

export default function Facet({facet, count, isActive, type}: FacetProps) {
    const dispatch = useDispatch();
    const { isMobile } = useResponsive();

    const handleToggle = useCallback((e: MouseEvent<HTMLDivElement>) => {
        if (isActive) {
            dispatch(unselectFacet(type, facet));
       } else {
            dispatch(selectFacet(type, facet));
       }

        e.currentTarget.blur();
   }, [isActive, dispatch, type, facet]);

    return (
        <div className={styles.facet}>
            <FormControlLabel
                control={
                    <div onClick={handleToggle} >
                        <Checkbox
                            icon={<div className={styles.checkedIcon}><CheckboxIcon /></div>}
                            checkedIcon={<div className={styles.checkedIcon}><CheckboxCheckedIcon /></div>}
                            checked={isActive}
                            name={facet}
                        />
                    </div>
               }
                label={<PuiTypography size={isMobile ? 14 : 16}>{facet}</PuiTypography>}
                className={styles.checkbox}
            />

            <div className={styles.count}>
                <PuiTypography size={isMobile ? 14 : 16}>{`${count} Video(s)`}</PuiTypography>
            </div>
        </div>
    );
}
